import { createAction } from '@reduxjs/toolkit';

export const SET_USER_SETTINGS = 'SET_USER_SETTINGS';

export const setUserSettings = createAction(SET_USER_SETTINGS);
